import React, { useRef, useState } from "react";
import { postBidang } from "../../api";
import FormInput from "../../components/forms/Input";
import FormSelect from "../../components/forms/Select";
import LayoutModal, { NewSubmitButton } from "../../components/layouts/Modal";
import { LayoutAddBtn } from "../../components/layouts/TopContent";
import { saAlert } from "../../helpers";

const BidangCreate = (props) => {
  const { onFetchData } = props;
  const formRef = useRef();

  const [modal, setModal] = useState(false);

  const [form, setForm] = useState({});
  const [errors, setErrors] = useState({});

  const handleClose = () => {
    if (formRef.current) {
      formRef.current.reset();
    }
    setForm({});
    setErrors({});
    setModal(false);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    postBidang(form)
      .then((res) => {
        if (res.data === "success") {
          onFetchData();
          handleClose();
          saAlert("success", "Berhasil tambah data bidang !");
        }
      })
      .catch((err) => {
        if (err.response && err.response.status === 422) {
          setErrors(err.response.data.errors);
        }
      });
  };

  return (
    <>
      <LayoutAddBtn onClick={() => setModal(true)} add="Tambah Data" />
      <LayoutModal
        modal={modal}
        title="Tambah Data Bidang"
        onClose={handleClose}
      >
        <form onSubmit={handleSubmit} ref={formRef}>
          <FormInput
            label="Nama Bidang"
            name="nama"
            onChange={(e) => {
              setForm((prevState) => {
                return { ...prevState, [e.target.name]: e.target.value };
              });
            }}
            error={errors.nama}
          />
          <FormSelect
            label="Kriteria"
            name="kriteria"
            onChange={(e) => {
              setForm((prevState) => {
                return { ...prevState, [e.target.name]: e.target.value };
              });
            }}
            error={errors.kriteria}
          >
            <option value="">Pilih</option>
            <option value="1">Wajib</option>
            <option value="2">Pilihan</option>
          </FormSelect>
          <div className="row">
            <NewSubmitButton onClose={handleClose}/>
          </div>
        </form>
      </LayoutModal>
    </>
  );
};

export default BidangCreate;
